<script>
  import { getContext, onMount } from 'svelte';
  import Form from '../../../../components/inputs/form';
  import TextInput from '../../../../components/inputs/text';
  import RichTextInput from '../../../../components/inputs/richtext';
  import SectionNav from '../../../../components/navigation/section';
  import Preview from '../../../../components/buttons/preview.card';
  import CommunicationTypeInput from '../../../../components/inputs/communication.type';
  import DateTimeInput from '../../../../components/inputs/datetime';
  import {addNotification, ICONS} from '../../../../utils/notifications.store';
  import uuid from 'uuid-browser/v4';

  import {PROGRAM_COMMUNICATIONS} from '../../../../graphql/programs';
  import {UPDATE_COMMUNICATION, SEND_TEST_COMMUNICATION} from '../../../../graphql/communications';
  
  const client = getContext('apollo');

  import Loader from '../../../../components/ui/loader.html';

  export let program;
  export let id;

  let query = client.watchQuery({ query: PROGRAM_COMMUNICATIONS, variables: {program: id }});
  let results = {loading: true, communications: []};
  let index = 0;
  
  let current = {}

  function setResponse({data, loading, error, networkStatus}) {
    results = {
      loading,
      communications: data && data.communications ? data.communications : []
    }
  }

  const subscription = query.subscribe({
    next: nextResult => {
      setResponse(nextResult);
    },
    error: error => {
      setResponse({error, loading: false});
    }
  });

  function changeEmail(i) {
    index = i;
  }

  const NAMES = {
      'Tips': 'Get Ready',
      'ThankYou': 'Thank You',
      'Reminder': 'Reminder'
    }

    const TIMES = {
      'Tips': 'Sends 7 days before the event',
      'ThankYou': 'Sends 2 days after the event',
      'Reminder': 'Sends 2 days before the event'
    }

  async function save(communication) {
    const input = {
      body: communication.body,
      subject: communication.subject,
      type: communication.type
    }

    const id = communication.id

    await client.mutate({mutation: UPDATE_COMMUNICATION, variables:{id, input}});

    addNotification({ icon: ICONS.SUCCESS, message:`Saved ${communication.subject}`, time: 3000});
  }

  async function sendTestCommunication(communication) {
    try {
      const input = {
        type: communication.type,
        subject: communication.subject,
        body: communication.body,
      }

      await client.mutate({mutation: SEND_TEST_COMMUNICATION, variables:{
        input,
        id: communication.id
      }})
      addNotification({ icon: ICONS.SUCCESS,  message:`Sent test for ${communication.subject}`, time: 3000});
    } catch (e) {
      console.log(e);
      addNotification({ icon: ICONS.ERROR,  message:`Couldn't sent test for ${communication.subject}`, time: 3000});
    }
  }

  function promptRemove(communication) {
    addNotification({
      message:`Are you sure you want to delete ${communication.subject}?`, 
      icon: ICONS.CONFIRM,
      confirm: () => remove(communication)
    })
  }

  function remove(communication) {
    results.communications = results.communications.filter((c) => c.id !== communication.id);
    addNotification({ icon: ICONS.SUCCESS, message:`Removed ${communication.subject}`, time: 3000});
  }

  function add(e) {
    e.preventDefault();
    results.communications = [...results.communications,{id:uuid(), type: 'Custom'}]

    return false;
  }

</script>


<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-12">
    {#if results.loading}
      <Loader></Loader>
    {/if}
    {#if !results.loading}
      <div class="grid-x grid-margin-x">
        <div class="cell small-12 medium-9">
        {#each results.communications as communication, i}
          {#if index === i}
            <Form>
              {#if communication.type === 'Custom'}
              <div class="help">
                {communication.date ? `Sends on ${communication.date}` : ''}
              </div>
              {:else}
              <div class="help">
                {TIMES[communication.type] ? TIMES[communication.type] : ''}
              </div>
              {/if}
              <div class="form-group">
                <TextInput bind:value={communication.subject} placeholder="Subject" label="Subject" />
              </div>
              <!--<div class="form-group">
                <CommunicationTypeInput bind:value={communication.type} placeholder="Type" label="Type" ></CommunicationTypeInput>
              </div>-->
              {#if communication.type === 'Custom'}
              <div class="form-group">
                <DateTimeInput bind:value={communication.date} label="Send On Date" placeholder="Send On Date"></DateTimeInput>
              </div>
              {/if}
              <div class="form-group">
                <RichTextInput bind:value={communication.body} placeholder="Body" label="Body" />
              </div>
              <div class="grid-x grid-margin-x">
                <div class="cell small-12 medium-6">
                  <div on:click="{e => sendTestCommunication(communication)}" class="button secondary small">
                    SEND TEST COMMUNICATION
                  </div>
                </div>
                <div class="cell small-12 medium-6">
                <div class="text-right">
                  <div on:click="{e => save(communication)}" class="button save">
                    SAVE COMMUNICATION
                  </div>
                </div>
                </div>
              </div>
            </Form>
          {/if}
        {/each}
        </div>
        <div class="cell small-12 medium-3">
          <SectionNav hasSub>
              <ul>
                {#each results.communications as communication, i}
                  <li class:active={i === index} on:click={() => changeEmail(i)}>
                    {NAMES[communication.type] ? NAMES[communication.type] : communication.type}
                  </li>
                {/each}
              </ul>
              
            </SectionNav>
          </div>
      </div>
    {/if}
  </div>
</div>
